import { render, staticRenderFns } from "./exhibitorList.vue?vue&type=template&id=6b1984cc&scoped=true&"
import script from "./exhibitorList.vue?vue&type=script&lang=js&"
export * from "./exhibitorList.vue?vue&type=script&lang=js&"
import style0 from "./exhibitorList.vue?vue&type=style&index=0&id=6b1984cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1984cc",
  null
  
)

export default component.exports